import React, { useState, useEffect, useMemo } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import { Container, Row, Col, FormGroup, Button } from 'reactstrap';
import './CalenderView.css';
import { SingleSelect } from '../CommonComponents';
import { fetchActiveInactiveUsers } from '../../constants/apiCalls';
import ModalService from '../../services/ModalService';
import { handleErrorMessage } from '../../utils/utils';
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi';

const localizer = momentLocalizer(moment);

const CalenderView = ({ setDate, currDate, setLoading, setSelectedTab }) => {
  const [activeInactiveData, setActiveInactiveData] = useState([]);

  const allEvents = useMemo(() => {
    if (!activeInactiveData.length) return [];

    return [
      ...activeInactiveData.map((data) => {
        return {
          id: Math.floor(Math.random() * 1000),
          title: `Active - ${data.active_count}`,
          type: true,
          start: moment(data.date).format('YYYY-MM-DD'),
          end: moment(data.date).format('YYYY-MM-DD'),
        };
      }),
      ...activeInactiveData.map((data, i) => {
        return {
          id: Math.floor(Math.random() * 1000),
          title: `In Active - ${data.inactive_count}`,
          type: false,
          start: moment(data.date).format('YYYY-MM-DD'),
          end: moment(data.date).format('YYYY-MM-DD'),
        };
      }),
    ];
  }, [activeInactiveData]);

  // on page load get events
  const handleEventPropGetter = (e) => {
    const backgroundColor = 'transparent';
    const color = e.type ? 'green' : 'red';
    const border = `1px solid ${e.type ? 'green' : 'red'}`;
    const borderRadius = '3px';
    const outline = 'none';
    return {
      style: { backgroundColor, color, outline, border, borderRadius },
    };
  };

  const monthArr = [
    { id: 1, monthName: 'January' },
    { id: 2, monthName: 'February' },
    { id: 3, monthName: 'March' },
    { id: 4, monthName: 'April' },
    { id: 5, monthName: 'May' },
    { id: 6, monthName: 'June' },
    { id: 7, monthName: 'July' },
    { id: 8, monthName: 'August' },
    { id: 9, monthName: 'September' },
    { id: 10, monthName: 'October' },
    { id: 11, monthName: 'November' },
    { id: 12, monthName: 'December' },
  ];

  const yearArr = [
    {
      id: new Date().getFullYear() - 11,
      yearName: new Date().getFullYear() - 11,
    },
    {
      id: new Date().getFullYear() - 10,
      yearName: new Date().getFullYear() - 10,
    },
    {
      id: new Date().getFullYear() - 9,
      yearName: new Date().getFullYear() - 9,
    },
    {
      id: new Date().getFullYear() - 8,
      yearName: new Date().getFullYear() - 8,
    },
    {
      id: new Date().getFullYear() - 7,
      yearName: new Date().getFullYear() - 7,
    },
    {
      id: new Date().getFullYear() - 6,
      yearName: new Date().getFullYear() - 6,
    },
    {
      id: new Date().getFullYear() - 5,
      yearName: new Date().getFullYear() - 5,
    },
    {
      id: new Date().getFullYear() - 4,
      yearName: new Date().getFullYear() - 4,
    },
    {
      id: new Date().getFullYear() - 3,
      yearName: new Date().getFullYear() - 3,
    },
    {
      id: new Date().getFullYear() - 2,
      yearName: new Date().getFullYear() - 2,
    },
    {
      id: new Date().getFullYear() - 1,
      yearName: new Date().getFullYear() - 1,
    },
    { id: new Date().getFullYear(), yearName: new Date().getFullYear() },
    {
      id: new Date().getFullYear() + 1,
      yearName: new Date().getFullYear() + 1,
    },
    {
      id: new Date().getFullYear() + 2,
      yearName: new Date().getFullYear() + 2,
    },
    {
      id: new Date().getFullYear() + 3,
      yearName: new Date().getFullYear() + 3,
    },
    {
      id: new Date().getFullYear() + 4,
      yearName: new Date().getFullYear() + 4,
    },
    {
      id: new Date().getFullYear() + 5,
      yearName: new Date().getFullYear() + 5,
    },
    {
      id: new Date().getFullYear() + 6,
      yearName: new Date().getFullYear() + 6,
    },
    {
      id: new Date().getFullYear() + 7,
      yearName: new Date().getFullYear() + 7,
    },
    {
      id: new Date().getFullYear() + 8,
      yearName: new Date().getFullYear() + 8,
    },
    {
      id: new Date().getFullYear() + 9,
      yearName: new Date().getFullYear() + 9,
    },
    {
      id: new Date().getFullYear() + 10,
      yearName: new Date().getFullYear() + 10,
    },
  ];

  const [monthId, setMonthId] = useState(moment(currDate).month() + 1);
  const [yearId, setYearId] = useState(moment(currDate).year());

  const customDayPropGetter = (dayInfo) => {
    if (moment(currDate).format('LL') === moment(dayInfo).format('LL')) {
      return {
        style: {
          border: '2px solid #006BFF',
          borderRadius: '10px',
        },
      };
    }
    if (moment(dayInfo).month() !== monthId - 1) {
      return {
        style: { backgroundColor: '#E6E6E6' },
      };
    }
  };

  const handleNavigate = (date) => {
    setMonthId(moment(date).month() + 1);
    setYearId(moment(date).year());

    setDate(moment(date));
  };

  useEffect(() => {
    setLoading(true);
    fetchActiveInactiveUsers(
      (res) => {
        const { data, success, error } = res;

        if (success) {
          setLoading(false);
          setActiveInactiveData(data);
        } else if (success === false || success === 'undefined') {
          setLoading(false);

          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
      },
      { month: monthId, year: yearId },
    );
  }, [monthId, yearId]);

  const prevMonth = () => {
    if (monthId === 1) {
      setMonthId(12);
      setDate(
        moment()
          .month(11)
          .year(yearId)
          .date(1),
      );
      return;
    }
    setDate(
      moment()
        .month(monthId - 2)
        .year(yearId)
        .date(1),
    );
    setMonthId(monthId - 1);
  };

  const nextMonth = () => {
    if (monthId === 12) {
      setMonthId(1);

      setDate(
        moment()
          .month(0)
          .year(yearId)
          .date(1),
      );

      return;
    }

    setDate(
      moment()
        .month(monthId)
        .year(yearId)
        .date(1),
    );
    setMonthId(monthId + 1);
  };

  const eventClick = (event) => {
    setMonthId(moment(event.start).month() + 1);
    setYearId(moment(event.start).year());

    setDate(moment(event.start));

    setSelectedTab(event.type === true ? 0 : 1);
  };

  return (
    <>
      <Container className="mt-3">
        <Row>
          <Col xs={12}>
            <span style={{ fontSize: '1.5rem' }}>
              Report of Login History for{' '}
              <strong>{moment(currDate).format('ll')}</strong>.
            </span>
          </Col>
        </Row>
        <Row>
          <div className="calender-big-toolbar">
            <div className="nextPrevCalenderBtn" onClick={prevMonth}>
              <FiArrowLeft size="26px" color="#7898CE" />
            </div>
            <div className="todayContainer">
              <Button
                color="primary"
                style={{ marginTop: '-22px', marginRight: '1rem' }}
                onClick={() => {
                  setDate(moment(Date.now()));
                  setMonthId(moment(Date.now()).month() + 1);
                  setYearId(moment(Date.now()).year());
                }}
              >
                Today
              </Button>
              <FormGroup style={{ margin: 0 }}>
                <SingleSelect
                  id="month"
                  name="month"
                  value={
                    monthId === null || monthId === 'undefined' ? '' : monthId
                  }
                  onChange={(e) => {
                    setDate(
                      moment()
                        .month(e.target.value - 1)
                        .year(yearId)
                        .date(1),
                    );

                    setMonthId(e.target.value);
                  }}
                  options={monthArr}
                  label={'monthName'}
                  selectedValueKey={'id'}
                />
              </FormGroup>
              <FormGroup style={{ margin: 0 }}>
                <SingleSelect
                  id="year"
                  name="year"
                  value={
                    yearId === null || yearId === 'undefined' ? '' : yearId
                  }
                  onChange={(e) => {
                    setDate(
                      moment()
                        .month(monthId - 1)
                        .year(e.target.value)
                        .date(1),
                    );
                    setYearId(e.target.value);
                  }}
                  options={yearArr}
                  label={'yearName'}
                  selectedValueKey={'id'}
                />
              </FormGroup>
            </div>
            <div className="nextPrevCalenderBtn" onClick={nextMonth}>
              <FiArrowRight size="26px" color="#7898CE" />
            </div>
          </div>
        </Row>
        <Row>
          <Col xs={12}>
            <Calendar
              onNavigate={handleNavigate}
              localizer={localizer}
              events={allEvents}
              // backgroundEvents={allEvents}
              onSelectEvent={eventClick}
              eventPropGetter={handleEventPropGetter}
              dayPropGetter={customDayPropGetter}
              startAccessor="start"
              endAccessor="end"
              views={['month']}
              toolbar={false}
              date={currDate}
              style={{ height: 500 }}
            />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CalenderView;
